import React, { useEffect, useState } from "react";
import TriggerEditor from "../TriggerEditor/TriggerEditor";
import useDiscordTriggers from "./useDiscordTriggers";
import DiscordTriggerTrack from "../DiscordTriggerTrack/DiscordTriggerTrack";
import { Route, Routes, useMatch, useNavigate } from "react-router-dom";
import DotsFishLoading from "../DotsFishLoading/DotsFishLoading";
import AutomationsPage from "./AutomationsPage";
import { randomBackgroundPosition } from "./TemplatesBox";
import { usePaywallStateDispatch } from "../Paywall/PaywallContext";
import Paywall from "../Paywall/Paywall";
import { getSupaClient, getWorkspace } from "../../lib/supabase";
import { updateWorkspace } from "../Admin/Admin";
import { checkAccess } from "../../lib/admin";
import useDiscordBotTemplates from "./useDiscordBotTemplates";

export default function DiscordTriggers() {
  const { botTemplates } = useDiscordBotTemplates();
  const [backgroundPosition, setBackgroundPosition] = useState<string[]>([]);
  const navigate = useNavigate();
  const matchEdit = useMatch("/automation/:triggerId/edit");
  const matchView = useMatch("/automation/:triggerId/view");
  const matchTrigger = useMatch("/automation/:triggerId");
  const match = matchEdit || matchView || matchTrigger;
  const { loadingPlanTier, userPlanTier } = usePaywallStateDispatch();
  const currentWorkspace = getWorkspace(getSupaClient());

  const {
    execTriggers,
    // callbacks
    changeTriggerVisibility,
    archiveTrigger,
    loadTriggers,
    loadExecTriggers,
    getTriggerById,
  } = useDiscordTriggers();

  useEffect(() => {
    loadTriggers();
    getTriggerById(match?.params.triggerId as string).then((triggers) => {
      const [trigger] = Array.isArray(triggers) ? triggers : [];
      if (checkAccess())
        if (trigger && currentWorkspace !== trigger.workspace!) {
          updateWorkspace(trigger?.workspace!);
        }
    });
  }, []);

  useEffect(() => {
    setBackgroundPosition([
      randomBackgroundPosition(),
      ...botTemplates.map(() => randomBackgroundPosition()),
    ]);
  }, [botTemplates]);

  const params = match?.params;
  const trigger = execTriggers?.find(
    (trigger) => trigger.trigger_id === params?.triggerId
  );

  const triggerEditorAndTracker = trigger ? (
    <TriggerEditor
      initialLiveTriggerId={trigger.trigger_id}
      mode={matchView ? "view" : "edit"}
      triggerTrack={trigger}
      editView={Boolean(matchEdit || matchView)}
    />
  ) : (
    <DotsFishLoading />
  );

  return (
    <div className="flex flex-col">
      <div
        style={{
          width: "100%",
          height: "100%",
          minHeight: "50vh",
          textAlign: "center",
          marginTop: "1rem",
        }}
      >
        <Routes>
          <Route path=":triggerId" element={triggerEditorAndTracker} />
          <Route
            path=":triggerId/edit"
            element={triggerEditorAndTracker}
          ></Route>
          <Route
            path=":triggerId/view"
            element={triggerEditorAndTracker}
          ></Route>
          <Route
            path="/"
            element={
              <AutomationsPage
                loadExecTriggers={loadExecTriggers}
                execTriggers={execTriggers}
                changeTriggerVisibility={changeTriggerVisibility}
                archiveTrigger={archiveTrigger}
                backgroundPosition={backgroundPosition}
                botTemplates={botTemplates}
              />
            }
          />
          <Route
            path="/new"
            element={
              <AutomationsPage
                loadExecTriggers={loadExecTriggers}
                execTriggers={execTriggers}
                changeTriggerVisibility={changeTriggerVisibility}
                archiveTrigger={archiveTrigger}
                newRoute
                backgroundPosition={backgroundPosition}
                botTemplates={botTemplates}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
}
